import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function QualificationSection() {
  return <section className="py-8 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]" data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <h2 className="text-2xl font-serif text-center text-white mb-6 leading-[1.05]" data-id="element-167">
          ¿Es esto para ti?
        </h2>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-168">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-169">
            <h3 className="text-base font-medium text-white mb-2 flex items-center gap-2 leading-[1.1]" data-id="element-170">
              <span className="text-green-500" data-id="element-171">Sí</span>, esto es para ti si:
            </h3>
            <ul className="space-y-1.5" data-id="element-172">
              {['Te duele la frialdad y no quieres perder la relación', 'No quieres rogar ni mendigar afecto', 'Quieres un primer paso práctico y rápido', 'Estás dispuesto/a a hacer algo pequeño, bien hecho'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-173">
                  <CheckCircle2 className="w-4 h-4 text-green-500/70 flex-shrink-0 mt-0.5" data-id="element-174" />
                  <span className="text-zinc-400 text-xs leading-[1.2]" data-id="element-175">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-176">
            <h3 className="text-base font-medium text-white mb-2 flex items-center gap-2 leading-[1.1]" data-id="element-177">
              <span className="text-red-500" data-id="element-178">No</span>, esto no es para ti si:
            </h3>
            <ul className="space-y-1.5" data-id="element-179">
              {['Hay abuso, amenazas, control o miedo', 'Estás buscando frases para ganar poder o castigar', 'Tu pareja ya terminó la relación definitivamente', 'Buscas una solución mágica sin poner de tu parte'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-180">
                  <XCircle className="w-4 h-4 text-red-500/70 flex-shrink-0 mt-0.5" data-id="element-181" />
                  <span className="text-zinc-400 text-xs leading-[1.2]" data-id="element-182">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}